var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGuidedTourImg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 475,
    height: 626,
    viewBox: "0 0 475 626",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M402.887 6.88861H275.248L214.82 64.9674H35.7667L1 98.383V257.304L79.9858 307.656V618.958",
    stroke: "url(#paint0_linear_13_86)",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M86.0588 618.84C86.0588 622.047 83.342 624.714 79.9064 624.714C76.4709 624.714 73.7541 622.047 73.7541 618.84C73.7541 615.632 76.4709 612.965 79.9064 612.965C83.342 612.965 86.0588 615.632 86.0588 618.84Z",
    fill: "#00FFFB",
    stroke: "url(#paint1_linear_13_86)",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M409.039 6.8886C409.039 10.0959 406.322 12.763 402.887 12.763C399.451 12.763 396.734 10.0959 396.734 6.8886C396.734 3.68126 399.451 1.01422 402.887 1.01422C406.322 1.01422 409.039 3.68126 409.039 6.8886Z",
    fill: "#00FFFB",
    stroke: "url(#paint2_linear_13_86)",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M450.194 195.151C450.194 198.358 447.477 201.025 444.041 201.025C440.606 201.025 437.889 198.358 437.889 195.151C437.889 191.944 440.606 189.276 444.041 189.276C447.477 189.276 450.194 191.944 450.194 195.151Z",
    fill: "#00FFFB",
    stroke: "url(#paint3_linear_13_86)",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M321.48 448.159C321.48 451.366 318.764 454.033 315.328 454.033C311.893 454.033 309.176 451.366 309.176 448.159C309.176 444.951 311.893 442.284 315.328 442.284C318.764 442.284 321.48 444.951 321.48 448.159Z",
    fill: "#00FFFB",
    stroke: "url(#paint4_linear_13_86)",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M315.328 24.9615H449.636V138.028L411.019 175.138V329.361L443.659 360.739V447.466H319.142",
    stroke: "url(#paint5_linear_13_86)",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M63.7921 133.711H41.2319V341.072L27.5978 353.012V442.684L41.2319 456.218V492.128H79.9065",
    stroke: "url(#paint6_linear_13_86)",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4483 4.64545L36.4484 16.1101H28.4211L37.421 4.64545H45.4483ZM50.6208 16.1101L59.6207 4.64545H67.6479L58.648 16.1101H50.6208ZM72.8204 16.1101L81.8203 4.64545H89.8476L80.8477 16.1101H72.8204ZM95.0201 16.1101L104.02 4.64545H112.047L103.047 16.1101H95.0201ZM117.22 16.1101L126.22 4.64545H134.247L125.247 16.1101H117.22ZM139.419 16.1101L148.419 4.64545H156.447L147.447 16.1101H139.419ZM161.619 16.1101L170.619 4.64545H178.646L169.646 16.1101H161.619Z",
    fill: "#73FAFD",
    stroke: "url(#paint7_linear_13_86)",
    strokeWidth: 2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M354.758 429.679L346.97 439.598H340.154L347.942 429.679H354.758ZM359.816 439.598L367.604 429.679H374.42L366.631 439.598H359.816ZM379.47 439.598L387.258 429.679H394.074L386.286 439.598H379.47ZM399.125 439.598L406.913 429.679H413.729L405.941 439.598H399.125Z",
    fill: "#00FFFB",
    stroke: "url(#paint8_linear_13_86)",
    strokeWidth: 2
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M79.9065 597.149H441.064L473.927 565.563V322.5L444.041 293.776V190.875",
    stroke: "url(#paint9_linear_13_86)",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M55.3636 513.548H41.7655V526.618H55.3636V513.548Z",
    stroke: "url(#paint10_linear_13_86)",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7655 538.054H54.3636V549.124H42.7655V538.054Z",
    fill: "#00FFFB",
    stroke: "url(#paint11_linear_13_86)",
    strokeWidth: 2
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M55.3636 560.567H41.7655V573.637H55.3636V560.567Z",
    stroke: "url(#paint12_linear_13_86)",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_13_86",
    x1: 201.943,
    y1: 6.88861,
    x2: 201.943,
    y2: 618.958,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3DF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#3B29AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#73FAFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_13_86",
    x1: 79.9064,
    y1: 611.965,
    x2: 79.9064,
    y2: 625.714,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3DF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#3B29AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#73FAFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_13_86",
    x1: 402.887,
    y1: 0.0142212,
    x2: 402.887,
    y2: 13.763,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3DF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#3B29AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#73FAFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_13_86",
    x1: 444.041,
    y1: 188.276,
    x2: 444.041,
    y2: 202.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3DF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#3B29AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#73FAFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_13_86",
    x1: 315.328,
    y1: 441.284,
    x2: 315.328,
    y2: 455.033,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3DF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#3B29AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#73FAFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_13_86",
    x1: 382.482,
    y1: 24.9615,
    x2: 382.482,
    y2: 447.465,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3DF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#3B29AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#73FAFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_13_86",
    x1: 53.7521,
    y1: 133.711,
    x2: 53.7521,
    y2: 492.128,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3DF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#3B29AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#73FAFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_13_86",
    x1: 103.534,
    y1: 3.64545,
    x2: 103.534,
    y2: 17.1101,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3DF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#3B29AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#73FAFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_13_86",
    x1: 376.941,
    y1: 428.679,
    x2: 376.941,
    y2: 440.598,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3DF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#3B29AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#73FAFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_13_86",
    x1: 276.917,
    y1: 190.875,
    x2: 276.917,
    y2: 597.149,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3DF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#3B29AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#73FAFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_13_86",
    x1: 48.5646,
    y1: 513.548,
    x2: 48.5646,
    y2: 526.618,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3DF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#3B29AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#73FAFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_13_86",
    x1: 48.5646,
    y1: 537.054,
    x2: 48.5646,
    y2: 550.124,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3DF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#3B29AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#73FAFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_13_86",
    x1: 48.5646,
    y1: 560.567,
    x2: 48.5646,
    y2: 573.637,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3DF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#3B29AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#73FAFD"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuidedTourImg);
export default __webpack_public_path__ + "static/media/guided-tour-img.44aa5d6c8e149f212b5e0e5ac424f4a7.svg";
export { ForwardRef as ReactComponent };